import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { UsersComponent } from './components/users/users.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { RestrictedAccessGuard } from './guards/restricted-access.guard';
import { SuspiciousUsersComponent } from './components/suspicious-users/suspicious-users.component';
import { BannedUsersComponent } from './components/banned-users/banned-users.component';
import { SilentHiddenUsersComponent } from './components/silent-hidden-users/silent-hidden-users.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { UnderReviewUsersComponent } from './components/under-review-users/under-review-users.component';
import { ReportedUsersComponent } from './components/reported-users/reported-users.component';
import { AlgorithmComponent } from './modules/algorithm/algorithm.component';
import { MessageFlagsComponent } from './components/message-flags/message-flags.component';
import { BlockAllowComponent } from './components/block-allow/block-allow.component';
import { MessageFlagDetailComponent } from './components/message-flag-detail/message-flag-detail.component';

const routes: Routes = [
    {
      path: 'login',
      component: LoginComponent,
      canActivate: [LoginGuard],
    },
    {
      path: 'users',
      component: UsersComponent,
      canActivate: [AuthGuard],
    },
    {
      path: 'users/:id',
      component: EditUserComponent,
      canActivate: [AuthGuard],
    },
    {
      path: 'reported-users',
      component: ReportedUsersComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'banned-users',
      component: BannedUsersComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'under-review-users',
      component: UnderReviewUsersComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'silent-hidden-users',
      component: SilentHiddenUsersComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'message-flags',
      component: MessageFlagsComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'message-flags/:userId',
      component: MessageFlagDetailComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'suspicious-users',
      component: SuspiciousUsersComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },
    {
      path: 'matches',
      canActivate: [RestrictedAccessGuard],
      canLoad: [RestrictedAccessGuard],
      loadChildren: () => import('./modules/matches/matches-page.module')
          .then(m => m.MatchesPageModule),
    },
    {
      path: 'prompts',
      canActivate: [RestrictedAccessGuard],
      canLoad: [RestrictedAccessGuard],
      loadChildren: () => import('./modules/prompts/prompts.module')
          .then(m => m.PromptsModule),
    },

    {
      path: 'block-allow',
      component: BlockAllowComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },

    {
      path: 'algorithm',
      component: AlgorithmComponent,
      canActivate: [AuthGuard, RestrictedAccessGuard],
    },

    {
      path: 'verifications',
      canActivate: [RestrictedAccessGuard],
      canLoad: [RestrictedAccessGuard],
      loadChildren: () => import('./modules/verifications/verifications.module')
          .then(m => m.VerificationsModule),
    },


    // Analytics module
    {
      path: 'analytics',
      canActivate: [RestrictedAccessGuard],
      canLoad: [RestrictedAccessGuard],
      loadChildren: () => import('./modules/analytics/analytics.module')
          .then(m => m.AnalyticsModule),
    },


    // Tools module
    {
      path: 'tools',
      loadChildren: () => import('./modules/tools/tools.module')
          .then(m => m.ToolsModule),
    },


    {
      path: '**',
      redirectTo: '/users',
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
